/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MedicineManufacturersApi } from '../api/medicinemanufacturer.api';
import { switchMap, map } from 'rxjs/operators';
import { MedicineManufacturersData, MedicineManufacturers } from '../../../interfaces/masters/medicinemanufacturer';

@Injectable()
export class MedicineManufacturersService extends MedicineManufacturersData {

  constructor(private api: MedicineManufacturersApi) {
    super();
  }


  list(): Observable<MedicineManufacturers[]> {
    return this.api.list();
  }
searchList(url: string,data:any): Observable<any> {
      debugger;
      return this.api.searchList(url,data);
    }
  getById(url:string): Observable<MedicineManufacturers>{
      return this.api.getById(url);
  }

  create(url: string, data:MedicineManufacturers): Observable<MedicineManufacturers> {
    return this.api.add(url,data);
  }

  update(url: string, data:MedicineManufacturers): Observable<MedicineManufacturers> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
  //uploadData
  postData(url: string, data:any[]): Observable<MedicineManufacturers> {
    return this.api.addData(url,data);
  }
}
